const TestimonialsData01 = [
  {
    name: "SHOKO MUGIKURA",
    designation: "GRAPHIC DESIGNER",
    content:
      "Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work.",
    img: "https://via.placeholder.com/125x125",
  },
  {
    name: "JONSAN DONNER",
    designation: "SALES MANAGER",
    content:
      "Trust us we looked for a very long time and wasted thousands of dollars testing other teams, freelancers, and outsource companies.",
    img: "https://via.placeholder.com/125x125",
  },
  {
    name: "MACKANGY ROSE",
    designation: "CREATIVE DIRECTOR",
    content:
      "This is an excellent company! I personally enjoyed the energy and the professional support the whole team gave to us into creating website.",
    img: "https://via.placeholder.com/125x125",
  },
];


const TestimonialsData03 = [
  {
    name: "—Akhila Sivadas",
    designation: "Executive Director, CFAR",
    content:
      "The entire exercise is exciting. Thank you very much for every point you raised, presented and cautioned everyone is both vital to know and make it part of our everyday practice and process.",
    img: "/Images/UserInfoImg1.png",
  },
  {
    name: "—Mini Bhargava",
    designation: "Chief - Collaborations & MIS, ETASHA,",
    content:
      "Wonderfully executed sessions, very insightful and these have given us a lot to rethink the ways of operation and planning the future. Experiencing the filling of the application for certification and overcoming the challenges. Looking forward to using this to further our cause to reach out to a larger funder base. Waiting to do a storming exercise within our management team to work towards collecting relevant information to fulfil the form requirement.",
    img: "/Images/UserInfoImg2.png",
  },
  {
    name: "—Radha Raj",
    designation: "Head Operations, 17000 ft Foundation",
    content:
      "Today's session was extremely informative. Even though we have an internal auditor who has put in a lot of checks and balances in our accounting process, this session will really help us in checking if we have missed anything important.",
    img: "/Images/UserInfoImg3.png",
  },
];



export {
  TestimonialsData01,
  TestimonialsData03,
};
